import React, { useState } from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import { Segment, Header, Icon, Button, Sidebar, Container, Popup, Confirm } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getOrders, getGlAccounts } from 'ducks/options'
import { getOptionTitle } from 'core/utilities'
import { showModal } from 'ducks/app'
import { getMappingOderGlAccounts, setFormOrderGlAccount, 
  createMappingOderGlAccount, updateMappingOderGlAccount,
  deleteMappingOderGlAccount } from 'ducks/mappingData'
import r from 'reactotron-react-js'

const columns = (props) => [
  {
    Header: 
      <div style={{ display: 'flex', width: '100%' }}>
        <Button content='Add' icon='plus' color='blue' basic onClick={() => props.setShowForm(true) } />
      </div>,
    columns: [
      {
        Header: 'Actions',
        accessor: '',
        headerStyle: { fontWeight: 'bold' },
        width: 90,
        resizable: false,
        Cell: row => (
          <div className='actionsContent'>
            <Popup 
              content='Edit' 
              trigger={
                <Button 
                  className='clear' 
                  icon='pencil' 
                  circular 
                  type='button' 
                  onClick={() => {
                    props.setFormOrderGlAccount({ ...row.original })
                    props.setShowForm(true)
                    props.setEditMode(true)
                  }} />
              } />
            <Popup 
              content='Remove' 
              trigger={
                <Button 
                  circular 
                  icon='trash' 
                  type='button' 
                  className='clear' 
                  onClick={() => {
                    props.setDeleteId(row.original.id)
                    props.setDeleteMessage(
                      `Are you sure to remove mapping data 
                      ${getOptionTitle(props.orderOptions, row.original.orderNo)} <-> 
                      ${getOptionTitle(props.glAccountOptions, row.original.glAccount)} ?`
                    )
                    props.setShowConfirmDelete(true)
                  }} />
              } />
          </div>
        )
      }, {
        Header: 'Active',
        accessor: 'active',
        width: 50,
        Cell: row => <Icon name={row.value ? 'check' : 'remove' } color={row.value ? 'green' : 'red'} /> 
      }, {
        Header: 'Order No',
        accessor: 'orderNo',
        Cell: row => 
          <React.Fragment>
            {getOptionTitle(props.orderOptions, row.value)} 
            {props.orderLoading ? <Icon style={{ marginLeft: '5px' }} name='spinner' loading /> : null}
          </React.Fragment>,
      }, {
        Header: 'GL Account',
        accessor: 'glAccount',
        Cell: row => 
          <React.Fragment>
            {getOptionTitle(props.glAccountOptions, row.value)} 
            {props.glAccountLoading ? <Icon style={{ marginLeft: '5px' }} name='spinner' loading /> : null}
          </React.Fragment>,
      }
    ]
  }
]

const MappingOrderGlAccount = (props) => {
  const { handleSubmit, orderGlAccounts, setFormOrderGlAccount, 
    createMappingOderGlAccount, updateMappingOderGlAccount, deleteMappingOderGlAccount,
    orderOptions, orderLoading, glAccountOptions, glAccountLoading, showModal } = props
  
  const [showForm, setShowForm] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [deleteId, setDeleteId] = useState(0)
  const [deleteMessage, setDeleteMessage] = useState('')

  const onSubmitData = (values)=> {
    const onSuccess = () => {
      setShowForm(false)
      setEditMode(false)
      setFormOrderGlAccount()
    }

    const submitData = () => {
      if (editMode) {
        updateMappingOderGlAccount(values, onSuccess)
      } else {
        createMappingOderGlAccount(values, onSuccess)
      }
    }

    const onDataDuplicate = () => {
      showModal(true, 'This order number has already mapping.', 'Please select another order number or remove current mapped data.')
      throw new SubmissionError('error.validationErrors')
    }

    let findDuplicateOrder = orderGlAccounts.find(o => o.orderNo === values.orderNo)
    if (findDuplicateOrder) {
      if (editMode) {
        if (values.id !== findDuplicateOrder.id) {
          onDataDuplicate()
        } else {
          submitData()
        }
      } else {
        onDataDuplicate()
      }
    } else {
      submitData()
    }
  }

  return (
    <Sidebar.Pushable as={Container}>
      <Sidebar
        as={Segment}
        animation='overlay'
        direction='top'
        visible={showForm}
      >
        <form onSubmit={handleSubmit(onSubmitData)} >
          <Field 
            require 
            name='orderNo' 
            label='Order No'
            loading={orderLoading} 
            options={orderOptions} 
            type={type.select} 
            component={FieldInput} />
          <Field 
            require 
            name='glAccount' 
            label='GL Account' 
            loading={glAccountLoading} 
            options={glAccountOptions} 
            type={type.select} 
            component={FieldInput} />
          <Field name='active' label='Active' type={type.switch} component={FieldInput} />
          <Button type='submit' color='blue' content={editMode ? 'Update' : 'Add'}  />
          <Button type='button' color='red' content='Cancel' 
            onClick={() => {
              setShowForm(false)
              setEditMode(false)
              setFormOrderGlAccount()
              props.reset('formOrderGl')
            }} />
        </form>
      </Sidebar>
      <Sidebar.Pusher>
        {orderGlAccounts ? 
          <ReactTable 
            columns={
              columns({
                setShowForm, setEditMode, setFormOrderGlAccount, 
                orderOptions, orderLoading, glAccountOptions, glAccountLoading,
                setShowConfirmDelete, setDeleteId, setDeleteMessage })} 
            data={orderGlAccounts} 
            minRows={5}/> :
          <Segment placeholder>
            <Header icon>
              <Icon name='file outline' />
              {'No mapping data'}
              <br />
              {'Order No <-> GL Account.'}
            </Header>
            <Button primary onClick={() => setShowForm(!showForm)} >Add Data</Button>
          </Segment>
        }
      </Sidebar.Pusher>
      <Confirm 
        open={showConfirmDelete}
        header='Are you sure to remove?'
        content={deleteMessage}
        confirmButton='Remove'
        onCancel={() => {
          setShowConfirmDelete(false)
          setDeleteId(0)
          setDeleteMessage('')
        }}
        onConfirm={() => {
          deleteMappingOderGlAccount(deleteId, () => {
            setShowConfirmDelete(false)
            setDeleteId(0)
            setDeleteMessage('')
          })
        }}
      />
    </Sidebar.Pushable>
  )
}

const mapStateToProps = (state) => {
  return ({
    initialValues: {
      ...state.mappingData.formOrderGlAccount
    },
    orderGlAccounts: state.mappingData.allOrderGlAccounts.data,
    orderOptions: state.options.orders.data,
    orderLoading: state.options.orders.loading,
    glAccountOptions: state.options.glAccounts.data,
    glAccountLoading: state.options.glAccounts.loading,
  })
}

const mapDispatchToProps = {
  getMappingOderGlAccounts,
  setFormOrderGlAccount,
  createMappingOderGlAccount, 
  updateMappingOderGlAccount,
  deleteMappingOderGlAccount,
  getOrders, 
  getGlAccounts,
  showModal
}

const validate = values => {
  const errors = {}

  if(!values.orderNo) {
    errors.orderNo = 'Required!'
  }

  if(!values.glAccount) {
    errors.glAccount = 'Required!'
  }

  return errors
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formOrderGl',
    enableReinitialize: true,
    validate,
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.orderGlAccounts.length) {
        this.props.getMappingOderGlAccounts(true)
      }

      if (!this.props.orderOptions.length) {
        this.props.getOrders()
      }

      if (!this.props.glAccountOptions.length) {
        this.props.getGlAccounts()
      }
    },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(MappingOrderGlAccount)